<template>
  <div class="feature">
    <span v-if="supported" class="feature-positive">
      <span class="feature-icon">&check;</span>
      <span class="feature-label">{{ label }}</span>
    </span>
    <span v-else class="feature-negative">
      <span class="feature-icon">&cross;</span>
      <span class="feature-label">{{ label }}</span>
    </span>
  </div>
</template>

<script>
const FeatureLabels = {
  singleShooting: "Single image",
  bulbShooting: "Bulb",
  burstShooting: "Burst",
  movieRecording: "Movie recording",
  touchFocus: "Focus point via touch",
  manualFocus: "Manual focus",
  focusLoupe: "Focus Loupe",
  setFocusMode: "Focus mode",
  aperture: "Aperture",
  shutterSpeed: "Shutter speed",
  isoSpeed: "ISO",
  exposureCompensation: "Exposure Compensation",
};
export default {
  props: {
    data: { required: true },
    name: String,
  },
  components: {},
  computed: {
    supported() {
      return !!this.data[this.name];
    },
    label() {
      return FeatureLabels[this.name] || this.name;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.feature {
  font-size: 80%;
}
.feature-positive {
  .feature-icon {
    color: var(--q-color-positive);
    font-weight: bold;
    margin-right: 2pt;
  }
}
.feature-negative {
  .feature-icon {
    color: var(--q-color-negative);
    font-weight: bold;
    margin-right: 2pt;
  }
  .feature-label {
    opacity: 0.33;
  }
}
</style>
